import { NetworkRequestLogEntryExtra } from '@/parsing/LogEntry';

export abstract class ExternalLinkBuilder {
  static buildLink(args: {
    dateFrom?: Date;
    dateTo?: Date;
    query?: string;
    isPrelive?: boolean;
  }): string {
    // Example url to build:
    // https://kibana-logs.elasticsearch.boltint.net/app/discover#/?_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:'2023-01-02T12:05:25.879Z',to:'2023-01-02T14:20:40.362Z'))&_a=(columns:!(),filters:!(),interval:auto,query:(language:kuery,query:getProviderAvailabilityStatus),sort:!(!('@timestamp',desc)))

    let timeQuery: string | undefined;
    if (args.dateFrom || args.dateTo) {
      timeQuery = 'time:(mode:absolute,';

      // The Kibana and device logs timestamps might be off by a small amount, so let's add a buffer to the time range.
      const BUFFER_IN_MS = 50;

      if (args.dateFrom) {
        timeQuery += `from:'${new Date(args.dateFrom.getTime() - BUFFER_IN_MS).toISOString()}'`;
      }
      if (args.dateTo) {
        if (args.dateFrom) {
          timeQuery += ',';
        }
        timeQuery += `to:'${new Date(args.dateTo.getTime() + BUFFER_IN_MS).toISOString()}'`;
      }

      timeQuery += ')';
    }

    let query: string | undefined;
    if (args.query) {
      query = encodeURIComponent(args.query);
    }

    let g = `(refreshInterval:(display:Off,pause:!f,value:0)`;
    if (timeQuery) {
      g += `,${timeQuery}`;
    }
    g += ')';

    const url = `https://kibana-logs${
      args.isPrelive ? '.prelive' : ''
    }.elasticsearch.boltint.net/app/discover#/?_g=${g}&_a=(columns:!(),filters:!(),interval:auto,query:(language:kuery,query:'${query}'),sort:!(!('@timestamp',desc)))`;

    return url;
  }

  static buildKibanaLinkFromNetworkExtra(extra: NetworkRequestLogEntryExtra) {
    const dateFrom = extra.request?.date;
    const dateTo = extra.response?.date;
    const isPrelive = extra.url?.hostname.includes('.prelive.');

    const query = this.buildKibanaQuery(extra);

    return this.buildLink({
      dateFrom,
      dateTo,
      query,
      isPrelive,
    });
  }

  private static buildKibanaQuery(extra: NetworkRequestLogEntryExtra): string {
    let query: string = '';

    const sessionIdQueryArgument = extra.request?.query?.find((kv) => kv.key === 'session_id');
    if (sessionIdQueryArgument && sessionIdQueryArgument.value) {
      query = sessionIdQueryArgument.value;
    }

    return query;
  }

  static buildGoogleMapsLinkFromNetworkExtra(extra: NetworkRequestLogEntryExtra) {
    const lat = extra.request?.query?.find((kv) => kv.key === 'gps_lat');
    const lng = extra.request?.query?.find((kv) => kv.key === 'gps_lng');

    if (lat && lng) {
      return `https://www.google.com/maps/search/?api=1&query=${lat.value},${lng.value}`;
    }

    return null;
  }
}
